module.exports = __webpack_public_path__ + "static/media/you-belong-to-me.fa7332cf.txt";